import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lt-png-table-expansion-footer',
  imports: [CommonModule],
  template: `
    <div class="footer-info">
        @if(expandedCount() > 0) {
            <small class="text-orange-600 fw-semibold">
                <i class="pi pi-angle-down me-1"></i>
                {{ expandedCount() }} expanded
            </small>
        } @else {
            <small class="text-muted">Details</small>
        }
    </div>
  `,
})
export class LTPngTableExpansionFooterComponent {
  expandedCount = input.required<number>();
}
